<template>
	<div id="app">
		<div class="full-loading"
			 v-loading.fullscreen.lock="fullScreenLoading"
			 element-loading-text="页面加载中，请稍候...."
			 element-loading-spinner="el-icon-loading"></div>
		<router-view />
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { getItem, setItem, removeItem } from './utils/auth' // get token from cookie

export default {
	data() {
		return {}
	},
	created() {
		// 初始页面加载状态
		this.setFullLoading(true)

		if (this.token) {
			// 加载码表
			this.getAllDict()
		}

		// 根据limitId 判断是否可编辑
		let queryParams = this.$route.query;
		// 如果是审计单位主体 1382233532112990209  则可编辑
        let limitId = queryParams.limitId || getItem("limitId");
		setItem("limitId", limitId);

        if (limitId && limitId === "1382233532112990209") {
            this.setBtnStatus(true);
        }

		setTimeout(() => {
			this.setFullLoading(false)
		}, 2000)
	},
	mounted() {
		// 存储浏览器窗口变化
		window.onresize = () => {
			return (() => {
				let obj = {}
				obj.width = document.documentElement.clientWidth
				obj.height = document.documentElement.clientHeight
				this.setClientSize(obj)
			})()
		}

		// 接收审计系统传过来的数据
		let that = this
		window.addEventListener('message', function (e) {  // 监听 message 事件
    	    // console.log(e);
    	    if (e.data &&e.data.from === 'audit') {
    	    	that.setProjectInfo(e.data)
    	    }
    	});
	},
	methods: {
		...mapActions('app', ['setClientSize', 'setFullLoading', 'setBtnStatus', 'setProjectInfo']),
		...mapActions('dict', ['getAllDict'])
	},
	computed: {
		...mapState('app', {
			fullScreenLoading: state => state.fullScreenLoading
		}),
		...mapState('user', {
			token: state => state.token
		})
	},
	watch: {
		// token有值时加载  初次登入时
		token() {
			// 加载码表
			this.getAllDict()
		}
	}
}
</script>

<style lang="less">
// 修改进度条颜色
// #nprogress .bar {
// 	background: red !important; //自定义颜色
// }
</style>
